import { ReviewEntry } from '@/domain/entities/review/reviewEntry'
import { ReviewPostRepository } from '@/domain/repositories/reviewPost/reviewPostRepository'

export class GetOpenReviewPostEntryListUseCase {
  constructor(private repository: ReviewPostRepository) {}

  async getByProblemIdOpenEntries(problemId: string): Promise<ReviewEntry[]> {
    try {
      return await this.repository.getByProblemIdOpenEntries(problemId)
    } catch (error) {
      console.error(
        `Error in GetOpenReviewPostEntryListUseCase: ${error instanceof Error ? error.message : String(error)}`
      )
      throw error
    }
  }
}
